import api from './api';
import { ReportFormat, ReportFormatType } from '../types/reportFormat';

export const reportFormatService = {
  getFormat: async (type: ReportFormatType): Promise<ReportFormat> => {
    const res = await api.get(`/users/me/report-format/${type}`);
    return res.data;
  },

  updateFormat: async (type: ReportFormatType, data: Partial<ReportFormat>): Promise<ReportFormat> => {
    const res = await api.put(`/users/me/report-format/${type}`, data);
    return res.data;
  },

  resetFormat: async (type: ReportFormatType): Promise<void> => {
    await api.delete(`/users/me/report-format/${type}`);
  },
};
